module.exports = __webpack_public_path__ + "img/mamalous.27a29574.png";